import {
  ADD_PENDING_CALL,
  REMOVE_PENDING_CALL,
} from "features/application/loader/redux/types";

const initialState = { pendingCallsNumber: 0 };

const loaderReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_PENDING_CALL:
      return { ...state, pendingCallsNumber: state.pendingCallsNumber + 1 };
    case REMOVE_PENDING_CALL:
      return { ...state, pendingCallsNumber: state.pendingCallsNumber - 1 };
    default:
      return state;
  }
};

export default loaderReducer;
